import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useReferralOverlay } from "../context/ReferralOverlayContext";

/**
 * Bookmark / old-link fallback. Opens the shared overlay, then replaces
 * /referral with Home so this route never renders a blank page.
 */
export default function ReferralRouteFallback() {
  const { openReferral } = useReferralOverlay();

  useEffect(() => {
    openReferral();
  }, [openReferral]);

  return <Navigate to="/" replace />;
}
